/**
 * Prevents an objects from being converted to json and thus sent to the client
 */
export function taint<T>(message: string, obj: T): T {
  Object.defineProperty(obj, 'toJSON', {
    enumerable: false,
    value() {
      throw new Error(message);
    },
  });
  return obj;
}
